var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMultipleTabs = function SvgMultipleTabs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "344px",
    height: "285px",
    viewBox: "0 0 344 285",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 23")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 183.261722,
    height: 148.930693,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.4%",
    y: "-12.1%",
    width: "132.7%",
    height: "140.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.137254902   0 0 0 0 0.549019608   0 0 0 0 0.960784314  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEDDFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DEFC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78DB2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC547A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 0,
    width: 183.261722,
    height: 148.930693,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.4%",
    y: "-12.1%",
    width: "132.7%",
    height: "140.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.137254902   0 0 0 0 0.549019608   0 0 0 0 0.960784314  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_Open_in_another_tab-Copy",
    transform: "translate(-19.000000, -137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(-11.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    opacity: 0.800851004
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(199.461832, 168.000000) scale(-1, 1) translate(-199.461832, -168.000000) translate(0.961832, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(198.500000, 168.000000) scale(-1, 1) translate(-198.500000, -168.000000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.757725,85.1057696 C216.985451,91.5192784 187.562118,81.5041018 166.922632,81.9552227 C147.840182,82.374225 128.295578,88.8242324 115.076801,102.61043 C108.873438,109.082336 104.228569,116.971842 101.110122,125.379627 C94.0670082,144.373424 95.5117869,167.434609 108.662042,182.831118 C125.091115,202.064345 153.282522,204.280532 177.315999,212.110181 C195.112581,217.909055 211.677238,227.470191 225.606012,239.986242 C232.251119,245.95593 238.42824,252.678946 246.315478,256.867509 C257.325536,262.714561 270.828604,262.917493 282.60406,258.836965 C294.380974,254.754978 304.507545,246.688819 312.448725,237.072205 C324.453072,222.53706 332.155156,204.106799 347.205055,192.764538 C355.859148,186.242994 367.071855,181.84712 371.699228,172.042174 C373.407887,168.422987 374.018747,164.352679 373.916694,160.352449 C373.463287,142.5777 360.031657,128.330162 349.663074,113.895752 C340.663459,101.368022 333.518292,87.5044482 328.533733,72.9021455 C323.829091,59.121788 320.507995,43.8143351 309.639352,34.1393241 C292.090613,18.5179845 278.973889,42.9748706 271.386979,55.5785178 C266.078766,64.3950851 259.213516,72.2699922 251.203815,78.7287591 C247.484713,81.7260124 243.28742,83.771386 238.757725,85.1057696",
    id: "Fill-1",
    fill: "#E7F2FE",
    opacity: 0.318010603,
    transform: "translate(235.430369, 145.354457) scale(-1, 1) rotate(13.000000) translate(-235.430369, -145.354457) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.241631,149.275057 C294.658654,146.46747 290.260805,143.604316 288.559681,138.673491 C286.811911,133.600824 288.663177,128.08801 290.11212,122.921757 C297.559457,96.3681236 276.576014,70.1639763 249.190397,84.7239481 C239.460318,89.8975124 232.062543,99.3935913 221.482631,102.462927 C204.73086,107.322101 188.452839,96.8755365 172.543614,93.7608694 C155.086322,90.3449717 135.923533,99.2853822 127.277975,114.877727 C124.517111,119.85827 122.760594,125.376934 119.703819,130.182002 C112.406624,141.652166 96.261253,145.85331 83.3330029,146.318317 C78.0984391,146.506952 72.7953639,145.822602 67.6540923,146.828655 C61.4355879,148.043813 55.9707092,151.620563 50.6836686,155.122735 C36.9988775,164.18744 27.4262291,179.286995 27.6915286,196.237803 C27.9262167,211.284715 36.6315397,225.404539 48.6254107,234.444385 C60.617824,243.482769 75.5591436,247.894483 90.4756825,249.491298 C96.3545451,250.121543 102.417077,250.37598 107.828021,252.766816 C117.588711,257.080557 115.973591,264.182875 118.642621,272.563231 C120.439952,278.203264 123.718297,283.474802 128.464534,286.994522 C135.050376,291.877091 143.707596,292.941635 151.892523,292.665263 C159.943344,292.393278 168.412521,290.768679 174.43278,285.399169 C180.136719,280.311879 183.03898,272.390681 189.403253,268.167602 C196.978866,263.140266 207.066079,264.845291 215.710179,267.641179 C231.120875,272.627571 246.48784,280.599949 262.558869,278.618553 C280.610899,276.392955 295.884572,260.027061 296.910785,241.811377 C297.106116,238.348686 296.804374,234.733918 295.1222,231.705525 C290.410947,223.224272 281.000102,216.140964 284.951899,204.853586 C287.92267,196.360635 299.15417,193.270826 305.756046,188.33269 C315.914686,180.736119 316.784927,163.565969 307.448424,154.975044 C305.050524,152.766994 302.108907,151.032724 299.241631,149.275057",
    id: "Fill-1",
    fill: "#E7F2FE",
    opacity: 0.329799107,
    transform: "translate(170.815305, 186.630780) scale(-1, 1) rotate(20.000000) translate(-170.815305, -186.630780) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.192608,135.656399 C369.519057,122.44646 363.128054,107.409084 349.917665,102.068935 C336.707277,96.7276772 312.499737,99.3960558 307.173287,112.604886 C301.845729,125.814824 322.257332,134.893116 331.25018,145.950914 C343.793826,161.372409 358.866158,148.865229 364.192608,135.656399",
    id: "Fill-6",
    fill: "#E7F2FE",
    opacity: 0.329799107,
    transform: "translate(336.185108, 126.278545) scale(-1, 1) rotate(-420.000000) translate(-336.185108, -126.278545) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.448059,29.2465235 C238.855259,17.0489197 221.18643,14.9418181 208.982644,24.5407853 C196.780065,34.1397522 186.185523,58.4797906 195.778323,70.6773944 C205.371123,82.8749982 225.007282,68.4931099 240.325397,65.981573 C261.690105,62.4772738 258.040859,41.4441273 248.448059,29.2465235",
    id: "Fill-8",
    fill: "#EEF2F6",
    opacity: 0.412434896,
    transform: "translate(224.057325, 47.021068) scale(-1, 1) rotate(-161.000000) translate(-224.057325, -47.021068) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(44.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.625918,201.293929 C282.625918,203.11291 281.150994,204.587859 279.332043,204.587859 C277.513092,204.587859 276.038168,203.11291 276.038168,201.293929 C276.038168,199.474948 277.513092,198 279.332043,198 C281.150994,198 282.625918,199.474948 282.625918,201.293929",
    id: "Fill-10",
    fill: "#CDD9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.625918,18.2939294 C283.625918,20.1129104 282.150994,21.5878588 280.332043,21.5878588 C278.513092,21.5878588 277.038168,20.1129104 277.038168,18.2939294 C277.038168,16.4749484 278.513092,15 280.332043,15 C282.150994,15 283.625918,16.4749484 283.625918,18.2939294",
    id: "Fill-12",
    fill: "#CDD9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.625918,3.29392939 C260.625918,5.11311954 259.151203,6.58785878 257.332043,6.58785878 C255.512883,6.58785878 254.038168,5.11311954 254.038168,3.29392939 C254.038168,1.47473924 255.512883,0 257.332043,0 C259.151203,0 260.625918,1.47473924 260.625918,3.29392939",
    id: "Fill-14",
    fill: "#3796F6",
    opacity: 0.34421503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1840543,23.7060706 C80.1840543,25.5252608 78.7093395,27 76.8901794,27 C75.0710194,27 73.5963046,25.5252608 73.5963046,23.7060706 C73.5963046,21.8868805 75.0710194,20.4121412 76.8901794,20.4121412 C78.7093395,20.4121412 80.1840543,21.8868805 80.1840543,23.7060706",
    id: "Fill-16",
    fill: "#CDD9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6259177,55.2939294 C32.6259177,57.1131195 31.1512028,58.5878588 29.3320428,58.5878588 C27.5128828,58.5878588 26.0381679,57.1131195 26.0381679,55.2939294 C26.0381679,53.4747392 27.5128828,52 29.3320428,52 C31.1512028,52 32.6259177,53.4747392 32.6259177,55.2939294",
    id: "Fill-18",
    fill: "#3796F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.508574,254.235224 C137.508574,254.917067 136.955203,255.470447 136.273371,255.470447 C135.591539,255.470447 135.038168,254.917067 135.038168,254.235224 C135.038168,253.55338 135.591539,253 136.273371,253 C136.955203,253 137.508574,253.55338 137.508574,254.235224",
    id: "Fill-20",
    fill: "#3796F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36696878,100.479492 C6.93983561,102.480812 4.9707723,103.756062 2.97017106,103.328922 C0.968884209,102.901782 -0.307030426,100.932686 0.120788345,98.9320517 C0.547921508,96.9307317 2.51629922,95.6547959 4.51758607,96.0826218 C6.51887291,96.509762 7.79410194,98.4781723 7.36696878,100.479492",
    id: "Fill-22",
    fill: "#CDD9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3669688,113.479492 C25.9398356,115.480812 23.9707723,116.756062 21.9701711,116.328922 C19.9688842,115.901782 18.6929696,113.932686 19.1207883,111.932052 C19.5479215,109.930732 21.5162992,108.654796 23.5175861,109.082622 C25.5188729,109.509762 26.7941019,111.478172 26.3669688,113.479492",
    id: "Fill-22",
    fill: "#CDD9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.139495,266.417896 C118.908597,267.498028 117.846245,268.186293 116.766132,267.955391 C115.686018,267.725599 114.997765,266.662119 115.228663,265.583097 C115.45956,264.502964 116.521913,263.813589 117.602026,264.044491 C118.68103,264.275393 119.370393,265.337763 119.139495,266.417896",
    id: "Fill-24",
    fill: "#3796F6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(90.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(34.534653, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-3",
    transform: "translate(0.000000, 0.203624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6EB3F8",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 183.465347,
    height: 12.950495
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "dot--red",
    fill: "#ED5E82",
    cx: 2.49522472,
    cy: 2.49485346,
    rx: 2.49522472,
    ry: 2.49485346
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "dot--yellow",
    fill: "#F8CD86",
    cx: 12.0481517,
    cy: 2.49653463,
    rx: 2.49690614,
    ry: 2.49653463
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "dot--green",
    fill: "#9DE2CF",
    cx: 22.4401064,
    cy: 2.49653463,
    rx: 2.49690614,
    ry: 2.49653463
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.916309, 6.658509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(0.000000, 5.966187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy",
    transform: "translate(0.801579, 0.000000)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape",
    x: 0,
    y: 0,
    width: 183.261722,
    height: 25.9009901
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.633663, 15.108911)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#0B7DEE",
    points: "2.89874229 6.80297294 -1.08357767e-13 4.13514041 2.89393167 1.36009978 3.34338105 1.82879164 0.947692182 4.12551917 3.3378832 6.32534707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#0B7DEE",
    points: "9.89407132 1.35577022 12.7928136 4.02360275 9.89888194 6.79864338 9.44943256 6.32995152 11.8451214 4.03322399 9.45493041 1.83339609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0388441,2.64252263 L25.7408041,1.41755233 L26.0988517,1.62303454 L25.1732123,3.23683746 C25.1752916,3.25147724 25.1772872,3.2661459 25.1791985,3.28084299 L25.1454522,3.2852358 L24.8666457,3.77132008 L22.8138853,2.38723592 L23.0441078,2.04499465 L24.4195115,2.97239688 C24.0640508,1.64508676 22.8472822,0.687231459 21.4392849,0.687231459 C19.7383871,0.687231459 18.3549901,2.07131562 18.3549901,3.77152625 C18.3549901,5.47242411 19.7383871,6.85582103 21.4392849,6.85582103 C22.3113817,6.85582103 23.1463679,6.48402882 23.7305146,5.83665678 L24.2411276,6.29641463 C23.5264069,7.0887925 22.5051809,7.54305249 21.4392849,7.54305249 C19.3597225,7.54305249 17.6677587,5.85108864 17.6677587,3.77152625 C17.6677587,1.69196385 19.3597225,-7.46069873e-14 21.4392849,-7.46069873e-14 C23.1066724,-7.46069873e-14 24.5545752,1.09849462 25.0388441,2.64252263 Z",
    id: "Combined-Shape",
    fill: "#0B7DEE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 32.0708014,
    y: 0,
    width: 136.529983,
    height: 8.24677751,
    rx: 4.12338875
  })), /*#__PURE__*/React.createElement("g", {
    id: "Controls",
    transform: "translate(8.174708, 0.305566)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-3",
    transform: "translate(70.148515, 72.306931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-5)",
    cx: 21.9914067,
    cy: 21.9914067,
    r: 21.9914067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5579248,20.8132956 L24.0858264,20.8132956 L24.0858264,10.3411972 C24.0858264,9.18507753 23.1475264,8.24677751 21.9914067,8.24677751 C20.835287,8.24677751 19.896987,9.18507753 19.896987,10.3411972 L19.896987,20.8132956 L9.42488858,20.8132956 C8.26876891,20.8132956 7.3304689,21.7515956 7.3304689,22.9077153 C7.3304689,24.063835 8.26876891,25.002135 9.42488858,25.002135 L19.896987,25.002135 L19.896987,35.4742334 C19.896987,36.6303531 20.835287,37.5686531 21.9914067,37.5686531 C23.1475264,37.5686531 24.0858264,36.6303531 24.0858264,35.4742334 L24.0858264,25.002135 L34.5579248,25.002135 C35.7140445,25.002135 36.6523445,24.063835 36.6523445,22.9077153 C36.6523445,21.7515956 35.7140445,20.8132956 34.5579248,20.8132956",
    id: "Path",
    fill: "#000000",
    opacity: 0.115141,
    transform: "translate(21.991407, 22.907715) rotate(-45.000000) translate(-21.991407, -22.907715) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5579248,19.896987 L24.0858264,19.896987 L24.0858264,9.42488858 C24.0858264,8.26876891 23.1475264,7.3304689 21.9914067,7.3304689 C20.835287,7.3304689 19.896987,8.26876891 19.896987,9.42488858 L19.896987,19.896987 L9.42488858,19.896987 C8.26876891,19.896987 7.3304689,20.835287 7.3304689,21.9914067 C7.3304689,23.1475264 8.26876891,24.0858264 9.42488858,24.0858264 L19.896987,24.0858264 L19.896987,34.5579248 C19.896987,35.7140445 20.835287,36.6523445 21.9914067,36.6523445 C23.1475264,36.6523445 24.0858264,35.7140445 24.0858264,34.5579248 L24.0858264,24.0858264 L34.5579248,24.0858264 C35.7140445,24.0858264 36.6523445,23.1475264 36.6523445,21.9914067 C36.6523445,20.835287 35.7140445,19.896987 34.5579248,19.896987",
    id: "Path-Copy",
    fill: "#FFFFFF",
    transform: "translate(21.991407, 21.991407) rotate(-45.000000) translate(-21.991407, -21.991407) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-2",
    transform: "translate(0.000000, 34.534653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-3",
    transform: "translate(0.000000, 0.203624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6EB3F8",
    mask: "url(#mask-7)",
    x: 0,
    y: 0,
    width: 183.465347,
    height: 12.950495
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    mask: "url(#mask-7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "dot--red",
    fill: "#ED5E82",
    cx: 2.49522472,
    cy: 2.49485346,
    rx: 2.49522472,
    ry: 2.49485346
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "dot--yellow",
    fill: "#F8CD86",
    cx: 12.0481517,
    cy: 2.49653463,
    rx: 2.49690614,
    ry: 2.49653463
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "dot--green",
    fill: "#9DE2CF",
    cx: 22.4401064,
    cy: 2.49653463,
    rx: 2.49690614,
    ry: 2.49653463
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    mask: "url(#mask-7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.916309, 6.658509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(0.000000, 5.966187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy",
    transform: "translate(0.801579, 0.000000)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape",
    x: 0,
    y: 0,
    width: 183.261722,
    height: 25.9009901
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.633663, 15.108911)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#0B7DEE",
    points: "2.89874229 6.80297294 -1.08357767e-13 4.13514041 2.89393167 1.36009978 3.34338105 1.82879164 0.947692182 4.12551917 3.3378832 6.32534707"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#0B7DEE",
    points: "9.89407132 1.35577022 12.7928136 4.02360275 9.89888194 6.79864338 9.44943256 6.32995152 11.8451214 4.03322399 9.45493041 1.83339609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0388441,2.64252263 L25.7408041,1.41755233 L26.0988517,1.62303454 L25.1732123,3.23683746 C25.1752916,3.25147724 25.1772872,3.2661459 25.1791985,3.28084299 L25.1454522,3.2852358 L24.8666457,3.77132008 L22.8138853,2.38723592 L23.0441078,2.04499465 L24.4195115,2.97239688 C24.0640508,1.64508676 22.8472822,0.687231459 21.4392849,0.687231459 C19.7383871,0.687231459 18.3549901,2.07131562 18.3549901,3.77152625 C18.3549901,5.47242411 19.7383871,6.85582103 21.4392849,6.85582103 C22.3113817,6.85582103 23.1463679,6.48402882 23.7305146,5.83665678 L24.2411276,6.29641463 C23.5264069,7.0887925 22.5051809,7.54305249 21.4392849,7.54305249 C19.3597225,7.54305249 17.6677587,5.85108864 17.6677587,3.77152625 C17.6677587,1.69196385 19.3597225,-7.46069873e-14 21.4392849,-7.46069873e-14 C23.1066724,-7.46069873e-14 24.5545752,1.09849462 25.0388441,2.64252263 Z",
    id: "Combined-Shape",
    fill: "#0B7DEE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 32.0708014,
    y: 0,
    width: 136.529983,
    height: 8.24677751,
    rx: 4.12338875
  })), /*#__PURE__*/React.createElement("g", {
    id: "Controls",
    transform: "translate(8.174708, 0.305566)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-4",
    transform: "translate(70.148515, 72.306931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EC5875",
    cx: 21.9914067,
    cy: 21.9914067,
    r: 21.9914067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5579248,20.8132956 L24.0858264,20.8132956 L24.0858264,10.3411972 C24.0858264,9.18507753 23.1475264,8.24677751 21.9914067,8.24677751 C20.835287,8.24677751 19.896987,9.18507753 19.896987,10.3411972 L19.896987,20.8132956 L9.42488858,20.8132956 C8.26876891,20.8132956 7.3304689,21.7515956 7.3304689,22.9077153 C7.3304689,24.063835 8.26876891,25.002135 9.42488858,25.002135 L19.896987,25.002135 L19.896987,35.4742334 C19.896987,36.6303531 20.835287,37.5686531 21.9914067,37.5686531 C23.1475264,37.5686531 24.0858264,36.6303531 24.0858264,35.4742334 L24.0858264,25.002135 L34.5579248,25.002135 C35.7140445,25.002135 36.6523445,24.063835 36.6523445,22.9077153 C36.6523445,21.7515956 35.7140445,20.8132956 34.5579248,20.8132956",
    id: "Path",
    fill: "#000000",
    opacity: 0.115141,
    transform: "translate(21.991407, 22.907715) rotate(-45.000000) translate(-21.991407, -22.907715) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5579248,19.896987 L24.0858264,19.896987 L24.0858264,9.42488858 C24.0858264,8.26876891 23.1475264,7.3304689 21.9914067,7.3304689 C20.835287,7.3304689 19.896987,8.26876891 19.896987,9.42488858 L19.896987,19.896987 L9.42488858,19.896987 C8.26876891,19.896987 7.3304689,20.835287 7.3304689,21.9914067 C7.3304689,23.1475264 8.26876891,24.0858264 9.42488858,24.0858264 L19.896987,24.0858264 L19.896987,34.5579248 C19.896987,35.7140445 20.835287,36.6523445 21.9914067,36.6523445 C23.1475264,36.6523445 24.0858264,35.7140445 24.0858264,34.5579248 L24.0858264,24.0858264 L34.5579248,24.0858264 C35.7140445,24.0858264 36.6523445,23.1475264 36.6523445,21.9914067 C36.6523445,20.835287 35.7140445,19.896987 34.5579248,19.896987",
    id: "Path-Copy",
    fill: "#FFFFFF",
    transform: "translate(21.991407, 21.991407) rotate(-45.000000) translate(-21.991407, -21.991407) "
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultipleTabs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multiple_tabs.503dca67.svg";
export { ForwardRef as ReactComponent };